// Frontend configuration
export const config = {
  // Backend API URL - must be set in .env file as REACT_APP_API_URL
  apiUrl: process.env.REACT_APP_API_URL,
  
  // Environment
  environment: process.env.NODE_ENV || 'development',
  
  // Other configuration options
  appName: 'SpeicoApp',
  version: '1.0.0'
};

export default config;
